import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { Main } from './components/mainpage.jsx';
import { Review } from './components/reviewPage/reviewpage.jsx';
import { Browse } from './components/browsePage/browsepage.jsx';
import { Dashboard } from './components/dashboard.jsx';
import './styles/app.css';

export default class App extends React.Component {
  render() {
    return (
      <Router>
        <div>
          <Route exact path="/" component={Main} />
          <Route path="/review" component={Review} />
          <Route path="/main" component={Main} />
          <Route path="/browse" component={Browse} />
          <Route path="/dashboard" component={Dashboard} />
        </div>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js